/**
 * Download a conformity document using the S3 temporary URL
 * @param {string} downloadUrl - The temporary S3 download URL (valid for 20 minutes)
 * @param {string} fileName - The filename for the downloaded file
 * @returns {Promise<void>} - Initiates the file download
 * @throws {Error} - Throws error if download fails
 */
export async function download(downloadUrl, fileName) {
  try {
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName || 'manufacture-declaration.pdf';
    
    document.body.appendChild(link);
    
    link.click();
    
    document.body.removeChild(link);
    
    return {
      success: true,
      message: 'Download avviato con successo'
    };
  } catch (error) {
    throw new Error('Errore durante il download del documento: ' + error.message);
  }
}

/**
 * Check if a download URL is still valid (not expired)
 * @param {string} downloadUrl - The S3 download URL to check
 * @returns {Promise<boolean>} - True if URL is valid, false if expired
 */
export async function isDownloadUrlValid(downloadUrl) {
  try {
    const response = await fetch(downloadUrl, {
      method: 'HEAD'
    });
    
    return response.ok;
  } catch (error) {
    console.warn('Unable to check download URL validity:', error);
    return false;
  }
}